// This function allow to reference chunks
__webpack_require__.miniCssF = (chunkId) => {
  // return url for filenames not based on template
  if (chunkId === 7486) return "webapp_static/css/PublicFiles.8756e018.chunk.css";
  // return url for filenames based on template
  return "" + chunkId + ".css"
}